/** @jsx jsx */
import React, { useState } from 'react'
import { jsx } from 'theme-ui'
import * as Sentry from '@sentry/browser'
import { ForwardRef } from '../types'
import { IButtonProps, Button } from './Button'
import { LoadingPlaceholder } from './LoadingPlaceholder'
import { ILoadingProps } from './Loading'
import { captureExceptionWithLabel } from '../utils/sentry'

export const AsyncActionButton: ForwardRef<
  HTMLButtonElement,
  IButtonProps & { action: () => Promise<any>; errorLabel: string } & ILoadingProps
> = React.forwardRef(
  ({ action, children, disabled, onClick, loadingVariant, errorLabel, ...props }, ref) => {
    const [loading, setLoading] = useState(false)

    return (
      <Button
        ref={ref}
        onClick={async (e) => {
          if (onClick) {
            onClick(e)
          }
          try {
            setLoading(true)
            await action()
            setLoading(false)
          } catch (e) {
            captureExceptionWithLabel(e, errorLabel)
            setLoading(false)
          }
        }}
        disabled={disabled || loading}
        {...props}
      >
        <LoadingPlaceholder loadingVariant={loadingVariant} loading={loading}>
          {children}
        </LoadingPlaceholder>
      </Button>
    )
  },
)
